import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import CheckboxesList from '../../../../FormComponents/CheckboxesList/CheckboxesList'
import InputField from '../../../../FormComponents/InputField/InputField'
import { checkValueInStore } from '../../../../AdditionalReportFilters/helpers'
import { showModal, hideModal } from '../../../../../store/reducers/modal'
import { clientConstants } from '../../../constants'

class UserExpandedBlock extends React.PureComponent {
  constructor (props) {
    super(props)
    this.showLoginDetails = this.showLoginDetails.bind(this)
    if (this.props.field === 'dashboardUsers') this.updatePermissionLevel()
  }

  showLoginDetails = () => () => {
    const { showModal, itemData } = this.props
    showModal(`Detailed-${itemData.UserId}`)
  }

  returnInputs = () => {
    const { field, updateData, itemData, trackData } = this.props
    const type = field === 'dashboardUsers' ? clientConstants.dashboardInputsUser : clientConstants.inputsUser
    return type.map((item, i) => {
      return <React.Fragment key={i}>
        <div className="input-user-row">
          <div>{item.title}</div>
          <InputField
            type="text"
            location={{ id: itemData.UserId, field }}
            id={item.fieldName}
            value={checkValueInStore(item.fieldName, itemData[item.fieldName], trackData[itemData.UserId])}
            updateData={updateData}
          />
          {item.fieldName === 'LastLogin' && field === 'dashboardUsers'
            ? <span className="permission-input-dashboard" onClick={this.showLoginDetails()}>
              | <span>View Details</span>
            </span>
            : null}
        </div>
      </React.Fragment>
    })
  }

  updatePermissionsList = () => {
    return clientConstants.permissions.map(item => {
      return {
        id: item.PermissionId,
        text: item.PermissionName,
        type: 'checkbox'
      }
    })
  }

  updatePermissionLevel = () => {
    const ids = this.props.itemData.Permissions.map(item => `${item.PermissionId}`)
    const selectedLevel = permissionLevel.filter(item => item.ids.length === ids.length)[0]
    const { trackData, itemData, updateData } = this.props
    if (selectedLevel && !trackData[itemData.UserId].permissions.selected.includes(selectedLevel.id)) {
      updateData({ id: itemData.UserId, field: '' }, 'checkbox-exclude-others', selectedLevel.id)
      updateData({ id: itemData.UserId, field: 'permissions' }, 'ch_selectall', ids)
    } else if (selectedLevel === undefined) {
      updateData({ id: itemData.UserId, field: '' }, 'checkbox-exclude-others', 'permission-1')
      updateData({ id: itemData.UserId, field: 'permissions' }, 'ch_selectall', ids)
    }
  }

  render () {
    const { trackData, updateData, modal, itemData, field, showModal, permissionEditing } = this.props
    const className = modal ? 'expanded-users' : 'expanded-users d-none'
    const dashboardView = field === 'dashboardUsers'
    return <div className={className} data-info={itemData.UserId}>
      {dashboardView
        ? <div className={`dashboard-user-permissions ${permissionEditing}`}>
          <div className="title">Permission Level</div>
          <CheckboxesList
            location={{ id: itemData.UserId, field: 'permissions' }}
            fieldData={permissionLevel}
            values={trackData[itemData.UserId]}
            updateData={updateData}
            openModal={showModal}
            isEdited={this.props.isEdited}
          />
        </div>
        : <div className="checkboxes-container user-permissions small-inner-pad">
          <CheckboxesList
            location={{ id: itemData.UserId, field: 'permissions' }}
            fieldData={this.updatePermissionsList()}
            values={trackData[itemData.UserId].permissions}
            updateData={updateData}
        />
        </div>}
      <div className="inputs-block users-inputs">
        {this.returnInputs()}
      </div>
    </div>
  }

  static propTypes = {
    field: PropTypes.string,
    trackData: PropTypes.object,
    updateData: PropTypes.func,
    itemData: PropTypes.object,
    modal: PropTypes.bool,
    showModal: PropTypes.func,
    isEdited: PropTypes.bool,
    permissionEditing: PropTypes.string
  }
}

export default connect(state => ({}), {
  showModal,
  hideModal
})(UserExpandedBlock)

const permissionLevel = [
  {
    ids: ['22', '23', '24', '27', '28', '29', '30', '31', '32', '38',
      '39', '40', '41', '42', '43', '48', '49', '50', '51', '52', '56',
      '57', '59', '60', '61', '62', '63'],
    id: 'permission-1',
    text: 'Administrator',
    type: 'checkbox-exclude-others',
  },
  {
    id: 'permission-2',
    ids: ['22', '23', '24', '27', '28', '29', '30', '31', '38',
      '39', '40', '41', '42', '48', '49', '50', '51', '52', '56', '57', '59'],
    text: 'Editor',
    type: 'checkbox-exclude-others',
  },
  {
    id: 'permission-3',
    ids: ['22', '23', '24', '27', '28', '29', '30', '38',
      '39', '40', '41', '48', '49', '50', '51', '56', '57', '59'],
    text: 'Asst. Editor',
    type: 'checkbox-exclude-others',
  },
  {
    id: 'permission-4',
    ids: ['22', '24', '27', '28', '38', '39', '48', '49', '56', '59'],
    text: 'Viewer',
    type: 'checkbox-exclude-others',
  },
  {
    id: 'permission-5',
    ids: ['27', '38', '48', '56', '59'],
    text: 'Guest',
    type: 'checkbox-exclude-others',
  }
]



// WEBPACK FOOTER //
// ./src/components/ClientContacts/components/ClientUsers/components/UserExpandedBlock.js